import { ScoopButton } from '../../../../ui'
import { useModal, MODALS } from '../../../../modals'
import { ClusterResult } from '../ClusterResult/ClusterResult'
import { EVENTS, trackEvent } from '../../../../../events'
import styles from './Cluster.module.scss'

export const Cluster = ({ mlResults, analyze, server, selectedInbox }) => {
    const saveModelModal = useModal(MODALS.INSIGHTS.SAVE_ML_MODEL)

    const handleSaveModel = async () => {
        const result = await saveModelModal.show()
        if (result?.modelName) {
            try {
                server.postData({
                    action: 'saveModel',
                    inboxID: selectedInbox.inboxID,
                    modelKey: mlResults.modelKey,
                    modelName: result.modelName,
                })
            } catch (e) {
                console.error(e)
            }
        }
    }

    return (
        <>
            {!mlResults && (
                <p className={styles.description}>
                    This machine learning analysis will examine your dataset to find common segments
                    or clusters that exist.
                </p>
            )}
            <ClusterResult
                mlResults={mlResults}
                onSaveModel={handleSaveModel}
                server={server}
                selectedInbox={selectedInbox}
            />
            {!mlResults && (
                <ScoopButton
                    onClick={() => {
                        let jsonBody = {
                            action: 'analyzeClusters',
                        }
                        trackEvent(EVENTS.DATA_SCIENCE.FIND_SEGMENTS)
                        analyze(jsonBody)
                    }}
                    variant="default"
                >
                    Analyze
                </ScoopButton>
            )}
        </>
    )
}
